module.exports = __webpack_public_path__ + "img/g2.65e7b123.jpg";